// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23LYo","top":"styles_top__fesJA"};